export default function getErrorMessage(exception) {
  const responseMessage = exception?.response?.data?.message
  return responseMessage || exception.message || exception
}
